
import React from 'react';

export const ChevronUpIcon = () => (
    <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 15L12 9L18 15" stroke="#323232" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);
